/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { MonitEntityPastebinResult } from './MonitEntityPastebinResult';
import {
    MonitEntityPastebinResultFromJSON,
    MonitEntityPastebinResultFromJSONTyped,
    MonitEntityPastebinResultToJSON,
} from './MonitEntityPastebinResult';

/**
 * 
 * @export
 * @interface MonitPaginatedEntityPastebinResponse
 */
export interface MonitPaginatedEntityPastebinResponse {
    /**
     * 
     * @type {number}
     * @memberof MonitPaginatedEntityPastebinResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof MonitPaginatedEntityPastebinResponse
     */
    page_size?: number;
    /**
     * 
     * @type {number}
     * @memberof MonitPaginatedEntityPastebinResponse
     */
    count?: number;
    /**
     * 
     * @type {Array<MonitEntityPastebinResult>}
     * @memberof MonitPaginatedEntityPastebinResponse
     */
    results?: Array<MonitEntityPastebinResult>;
}

/**
 * Check if a given object implements the MonitPaginatedEntityPastebinResponse interface.
 */
export function instanceOfMonitPaginatedEntityPastebinResponse(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MonitPaginatedEntityPastebinResponseFromJSON(json: any): MonitPaginatedEntityPastebinResponse {
    return MonitPaginatedEntityPastebinResponseFromJSONTyped(json, false);
}

export function MonitPaginatedEntityPastebinResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MonitPaginatedEntityPastebinResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'page': !exists(json, 'page') ? undefined : json['page'],
        'page_size': !exists(json, 'page_size') ? undefined : json['page_size'],
        'count': !exists(json, 'count') ? undefined : json['count'],
        'results': !exists(json, 'results') ? undefined : ((json['results'] as Array<any>).map(MonitEntityPastebinResultFromJSON)),
    };
}

export function MonitPaginatedEntityPastebinResponseToJSON(value?: MonitPaginatedEntityPastebinResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'page': value.page,
        'page_size': value.page_size,
        'count': value.count,
        'results': value.results === undefined ? undefined : ((value.results as Array<any>).map(MonitEntityPastebinResultToJSON)),
    };
}

